/* eslint-disable */
import React, { Fragment } from "react";
import './Spin.scss';

const Spin = ({ children, loading }) => {
    return (
        <div className="jspin-nested-loading">
            {
                loading ? <div className="jspin jspin-spinning">
                    <div className="jspin-dot jspin-dot-spin">
                        <div className="spinner-bubble spinner-bubble-primary"></div>
                    </div>
                </div>
                    : null
            }
            <div className={`jspin-container ${loading ? 'jspin-blur' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default Spin;